<template>
  <div>
    <Header :class="$style.header">
      <template #left>
        <RouterLink to="/">
          <Logo />
        </RouterLink>
      </template>
      <template #center>
        <h1
          v-if="!isTabletLandscapeUp"
          :class="$style.title"
        >
          捐款支持
        </h1>
      </template>
      <template #right>
        <nav :class="$style.navHeader">
          <ul :class="$style.list">
            <li
              v-if="isTabletLandscapeUp"
              :class="$style.item"
            >
              <MenuButton>
                <a
                  href="https://www.teach4taiwan.org/"
                  style="border: none; text-decoration: none;"
                  target="_blank"
                >
                  回到 TFT 官網
                </a>
              </MenuButton>
            </li>
            <li
              v-if="$route.name === 'Home'"
              :class="$style.item"
            >
              <RouterLink
                to="/search"
                :class="$style.btnLink"
              >
                <MenuButton v-if="isTabletLandscapeUp">
                  查詢捐款記錄
                </MenuButton>
                <Button
                  v-else
                  small
                  transparent
                  grayscale
                  style="color: #2f2f2f;"
                  :class="$style.navButton"
                >
                  <IconDonationSearch
                    width="30"
                    :class="$style.navButton__icon"
                  />
                </Button>
              </RouterLink>
            </li>
            <li
              v-else
              :class="$style.item"
            >
              <RouterLink
                v-if="$route.name !== 'period-result' && $route.name !=='single-result'"
                to="/"
                :class="$style.btnLink"
              >
                <MenuButton v-if="isTabletLandscapeUp">
                  返回捐款頁面
                </MenuButton>
                <Button
                  v-else
                  small
                  transparent
                  grayscale
                  style="color: #2f2f2f;"
                  :class="$style.navButton"
                >
                  <IconBack
                    width="27"
                    :class="$style.navButton__icon"
                  />
                </Button>
              </RouterLink>
            </li>
            <li
              v-if="isLoggedIn"
              :class="$style.item"
            >
              <Button
                small
                transparent
                @click.native="handleLogout"
              >
                登出
              </Button>
            </li>
          </ul>
        </nav>
      </template>
    </Header>

    <div :class="$style.container">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// libs
import { getStore } from '@/lib/storage';
// components
import Logo from './components/others/Logo';
import Header from './components/layout/Header';
import Button from './components/buttons/Button';
import MenuButton from './components/buttons/MenuButton.vue';
import IconBack from '@/images/icons/back.svg';
import IconDonationSearch from '@/images/icons/donation-search.svg';
// styles
import '@/styles/main.scss';

export default {
  name: 'App',
  components: {
    Logo,
    Header,
    Button,
    MenuButton,
    IconBack,
    IconDonationSearch,
  },
  computed: {
    isLoggedIn() {
      return !!this.$store.state?.member?.loginStatus;
    },
    ...mapGetters('ui', [
      'isTabletLandscapeUp',
    ]),
  },
  created() {
    getStore();
  },
  methods: {
    async handleLogout() {
      const result = await this.logout();
      if(result) {
        this.$router.push('/search');
      }
    },
    ...mapActions('member', [
      'logout',
    ]),
  },
};
</script>

<style lang="scss" module>
.header {
  overflow: hidden;
}

.title {
  color: white;
  margin: 0;
  white-space: nowrap;

  @include for-tablet-portrait-up {
    font-size: 2.6rem;
  }
}

.subTitle {
  font-size: 1.4rem;
  white-space: nowrap;
  margin: 0;
  font-weight: normal;
  color: $color-text;
}

.container {
  margin: 0 auto;
  padding: 0;
  text-align: center;
}

.navHeader {
  display: flex;
  padding: 5px;

  .list {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
  }
}

.navButton {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: none;

  &__icon {
    margin: 5px;
  }

  &__text {
    font-size: 1rem;
    font-weight: 500;
    color: $color-text--light;
  }
}

.btnLink {
  text-decoration: none;
}
</style>
